import Vue from 'vue'
import ElementUI from 'element-ui'
Vue.use(ElementUI);

import VueBus from 'vue-bus';
Vue.use(VueBus);

import apimit from './tools/apimit.js';
import cache from './tools/cache.js';
import loafun from './tools/lodfun.js';
import unipro from './tools/unipro.js';

import apimithttp from './tools/apimithttp.js';
import etcApi from './tools/etcApi.js';

import './index.scss';
import './tools/router.js'
import './components/index.js';

// 导入导出工具
import ExportUtil from './tools/export.js';

Vue.mixin({
	methods: {
		...unipro,
		
		/**
		 * 公共导出方法
		 */
		$export: function(apiPath, exportParams, filename) {
			if (filename === void 0) {
				filename = '';
			}
			
			const self = this;
			return ExportUtil.execute({
				apiPath: apiPath,
				exportParams: exportParams,
				filename: filename,
				getAuthHeaders: function() {
					return self.$apimit && self.$apimit.permit ? self.$apimit.permit() : null;
				},
				onSuccess: function(message) {
					if (self.$message && self.$message.success) {
						self.$message.success(message);
					}
				},
				onError: function(message) {
					if (self.$notify && self.$notify.error) {
						self.$notify.error({
							title: '导出失败',
							message: message,
							duration: 5000
						});
					}
				}
			});
		},
		
		/**
		 * 构建导出参数（快捷方法）
		 */
		$buildExportParams: function(searchParams, excludeFields) {
			if (excludeFields === void 0) {
				excludeFields = [];
			}
			return ExportUtil.buildExportParams(searchParams, excludeFields);
		}
	},
	beforeCreate: function(){
		this.$config = $config;
		this._ = loafun;
		this.$cache = cache;
		
		this.$apimit = apimit;
		// apimithttp
		this.$get  = apimithttp.get;
		this.$put  = apimithttp.put;
		this.$del  = apimithttp.del;
		this.$post = apimithttp.post;
		this.$save = apimithttp.save;
		
		// etcApi
		this.$etcGet   = etcApi.get;
		this.$etcPost  = etcApi.post;
		this.$download = etcApi.download;
		
		this.$query = (name, defval) => {
			const query = {};
			if (location.href.indexOf("?") !== -1) {
				const params = location.href.substr(location.href.indexOf("?") + 1).split("&");
				for (let param of params) {
					param = param.split("=");
					query[param[0]] = unescape(param[1]);
				}
			}
			return name ? (query[name] || defval || null) : query;
		};

		this.$loadImg = (path, local) => {
			if (path) {
				if (path.substring(0, 4) === 'http') {
					return path;
				} else if (local) {
					return require('../../static/' + path);
				} else {
					return $config.apihost + '/' + path;
				}
			} else {
				return '';
			}
		};
		
		// 初始化导出加载状态
		this.exportLoading = false;
	}
});

// 将导出工具类挂载到Vue原型
Vue.prototype.$ExportUtil = ExportUtil;